import { useEffect, useState } from 'react';
import { checkOverflow } from '@utils/checkOverflow';
/**
 * Checks for overflow on a one-off basis.
 * # Note
 *
 * Not suitable for layouts that change.
 */
export function useOverflow<T extends HTMLElement>(
  ref: React.MutableRefObject<T | null>,
  text: string,
  cb?: VoidFunction,
) {
  const [hasOverflow, setHasOverflow] = useState(false);
  // The function itself is not so complex , outside of the setState call.
  // The setstate combined with the expensive render is a bad time
  useEffect(() => {
    const isOverflow = checkOverflow(ref);
    if (isOverflow) {
      if (cb) cb();
    }
    setHasOverflow(isOverflow);
    // Only rerun when the text changes as that's the only cause for overflow.
  }, [text]);

  return hasOverflow;
}
